export default __webpack_public_path__ + "static/media/tdis.7f7d1198.png";